module.exports = __webpack_public_path__ + "static/img/header-bg.0e7a6e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/header-bg.png
// module id = woVx
// module chunks = 1